export default __webpack_public_path__ + "assets/landingLoadPic.8facdcd3.png";